<div [ngSwitch]="history?.status">
  <ng-template [ngSwitchCase]="actionListStatuses.FAILED">
    <div>Failed to Initialize</div>
    <div *ngIf="history.type === actionListHistoryTypes.LIST_IMPORT">
      <a (click)="handleRetryClicked(history)">Retry</a>
    </div>
  </ng-template>
  <ng-template [ngSwitchCase]="actionListStatuses.COMPLETED">
    <div>{{ history.numberOfAccounts }}</div>
    <div *ngIf="history.actions.indexOf('download-skipped-file') >= 0">
      <a (click)="downloadSkippedFile(history)">Download List of Errors</a>
    </div>
    <div *ngIf="history.actions.indexOf('view-inline-errors') >= 0">
      <a (click)="toggleInlineErrors(history)">
        <span *ngIf="!isErrorShowing; else hideError">View Errors</span>
        <ng-template #hideError>
          <span>Hide Errors</span>
        </ng-template>
      </a>
    </div>
  </ng-template>
  <ng-template [ngSwitchCase]="actionListStatuses.IN_PROGRESS">
    <div>
      <span class="history-progress-bar">
        <mat-progress-bar
          class="history-progress-bar"
          color="primary"
          mode="determinate"
          [value]="history.progressPercentage"
        ></mat-progress-bar>
      </span>
      <span>{{ history.progressPercentage }}%</span>
    </div>
  </ng-template>
  <ng-template ngSwitchDefault>
    <div>
      <span>Initializing ...</span>
    </div>
  </ng-template>
</div>
